/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SurfaceConditionTractionConfigs } from './SurfaceConditionTractionConfigs';
import type { WheelRollingResistanceConfigs } from './WheelRollingResistanceConfigs';
/**
 * Wheel with Database ID.
 */
export type WheelInDB = {
    item_type?: WheelInDB.item_type;
    name?: string;
    mass?: number;
    cost?: number;
    rolling_radius?: number;
    rolling_resistance_coefficient?: number;
    rolling_resistance_key?: (WheelRollingResistanceConfigs | null);
    traction_coefficient?: number;
    traction_coefficient_key?: (SurfaceConditionTractionConfigs | null);
    config_type?: 'wheel';
    _id?: string;
    id?: string; // TODO: This is required
};
export namespace WheelInDB {
    export enum item_type {
        CONFIG = 'config',
    }
}

